import React, { useState, useEffect } from 'react';
import ContentLoader from 'react-content-loader';

export default function Loader() {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHide(true);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  if (hide) return null;

  return (
    <ContentLoader speed={2} width={400} height={160} viewBox="0 0 400 160" backgroundColor="#f3f3f3" foregroundColor="#fbd195">
      <rect x="98" y="12" rx="3" ry="3" width="88" height="6" />
      <rect x="98" y="40" rx="3" ry="3" width="100" height="6" />
      <rect x="98" y="65" rx="3" ry="3" width="120" height="6" />
      <rect x="5" y="120" rx="3" ry="3" width="200" height="6" />
      <rect x="5" y="140" rx="3" ry="3" width="240" height="6" />
      <circle cx="40" cy="40" r="40" />
    </ContentLoader>
  );
}
